//TODO: see about using a interceptor option with a custom interceptor for these calls to handle the headers for example

import angular from "angular";
import $ from 'jquery';

angular
    .module('api-sentinel')
    .factory('SentinelAuthenticationService', SentinelAuthenticationService);

SentinelAuthenticationService.$inject = ['$http', 'SENTINEL_API_HOST_CONSTANTS', '$window'];

export function SentinelAuthenticationService($http, HOST, $window) {
    var apiHeaders = {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
    };

    var service = {
        login: login,
        refresh: refresh,
        logout: logout,
        reportLoginFailure: reportLoginFailure
    };

    return service;

    /**
     * One-way report of a failed login for the API's client-event log. navigator.sendBeacon
     * sends the body as text/plain, so there is no preflight, and the browser delivers it even
     * while the page is unloading, which is the one case where the login request itself leaves
     * no trace. There is no response to read and no error to handle: a lost report is lost.
     * Returns whether the browser accepted the report into its queue.
     */
    function reportLoginFailure(failure) {
        const navigator = $window ? $window.navigator : undefined;
        if (!navigator || typeof navigator.sendBeacon !== 'function') {
            return false;
        }
        try {
            return navigator.sendBeacon(HOST.URL + '/auth/web/client-event', JSON.stringify(failure));
        } catch (error) {
            return false;
        }
    }

    function login(username, password) {
        return $http.post(
            HOST.URL + '/auth/web/login',
            $.param({
                client_id: username,
                client_secret: password
            }),
            {
                headers: apiHeaders,
                withCredentials: true
            });
    }

    function refresh() {
        return $http.post(
            HOST.URL + '/auth/web/refresh',
            null,
            {withCredentials: true}
        );
    }

    function logout() {
        return $http.post(
            HOST.URL + '/auth/web/logout',
            null,
            {withCredentials: true}
        );
    }
}
